import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card } from '@themesberg/react-bootstrap'
import { Context } from '../Statistic'
import { getStatisticSummary } from '../../../../controller/api/__classic__/statistic-by-ticket';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { parseQuery } from '../../../../helper/helper';

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const location = useLocation();

  const [data, setData] = useState({
    count: 0,
    reward: 0,
    unReward: 0
  })

  const getSummaryFunc = useCallback(async () => {

    const queryObj = parseQuery(location.search);

    if (queryObj.resultId) {

      let phone = state.filter.phone

      if (phone.indexOf('MB') < 0) {
        phone = phone.replace('0', '+84')
      }

      const response = await getStatisticSummary(cookies.lottmekong, {
        phone: phone,
        resultId: queryObj.resultId
      })

      if (response) {
        const res = {
          count: response.total,
          reward: response.totalReward || 0,
          unReward: response.totalUnReward || 0
        }
        setData(res || {})
      }
    }
  }, [cookies.lottmekong, state.filter.phone, location.search])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  const formatNumber = (num) => {
    return new Intl.NumberFormat('vi-VN').format(num || 0)
  }

  return (
    <Row>
      <Col md={4}>
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <h6 className="text-muted">Tổng số vé</h6>
            <h4>{formatNumber(data.count)} vé</h4>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card border="light" className="shadow-sm bg-success text-white">
          <Card.Body>
            <h6>Trúng thưởng</h6>
            <h4>{formatNumber(data.reward)} vé</h4>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <h6 className="text-muted">Không trúng</h6>
            <h4>{formatNumber(data.unReward)} vé</h4>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default React.memo(_Summary)
